export default __webpack_public_path__ + "static/media/spices.d75dfa1e.jpg";